import { useUsersServiceUsersListKey } from '@organization/api/queries'
import { UsersService } from '@organization/api/requests'
import { InfiniteSelect } from '@shared/components'
import { getFullName } from '@shared/utils'
import { SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'

export const UserSelect = (props: SelectProps) => {
  const { t } = useTranslation()

  return (
    <InfiniteSelect
      placeholder={t('table.user')}
      apiCall={({ pageParam, pageSize, search }) =>
        UsersService.usersList(
          undefined,
          undefined,
          undefined,
          pageParam,
          pageSize,
          search
        )
      }
      queryKey={[useUsersServiceUsersListKey]}
      getOption={(data) => ({
        label: getFullName(data) || '-',
        value: String(data?.sso_id)
      })}
      style={{ minWidth: 200 }}
      {...props}
    />
  )
}
